import React, { useState, useMemo } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRBloqueadoReserva";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import '../ProductList/ProductList.css';
import AbmBloqueadoReserva from "../abmBloqueadoReserva/AbmBloqueadoReserva";
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

function BloqueadoReservaList({ bloqueados = [] }) {

    const navigate = useNavigate();
    const [filter, setFilter] = useState("");
    const [itemToEdit, setItemToEdit] = useState({});

    const listHeight = useMemo(() => window.innerHeight, []);

    const handdlerSearchInput = (data) => {
        setFilter(data);
    }

    let filtered = useMemo(() => bloqueados.filter(item => {
        return filter != '' ?
            checkDoubleQuotes(filter) ?
                normalizeText(item.nroSocio) == removeDoubleQuotesFromFilter(filter) || normalizeText(item.nombre) == removeDoubleQuotesFromFilter(filter) || normalizeText(item.textoAdicional) == removeDoubleQuotesFromFilter(filter)
                :
                normalizeText(item.nroSocio).includes(normalizeText(filter)) || normalizeText(item.nombre).includes(normalizeText(filter)) || normalizeText(item.textoAdicional).includes(normalizeText(filter))
            : true
    }), [bloqueados, filter]);

    return (
        <div className="productsListDiv">
            <SearchInput buscar={handdlerSearchInput} filter={filter} />
            <button style={{ cursor: 'pointer' }} onClick={() => navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong} /></button>
            <div className='container-product-list'>
                <FixedSizeList
                    height={listHeight}
                    itemCount={filtered.length}
                    itemSize={80}
                    width={"100%"}
                >
                    {({ index, style }) => (
                        <RenderRow
                            index={index}
                            style={style}
                            bloqueados={filtered}
                            setItemToEdit={setItemToEdit}
                        />
                    )}
                </FixedSizeList>
            </div>
            {Object.keys(itemToEdit).length > 0 && <AbmBloqueadoReserva itemToEdit={itemToEdit} setItemToEdit={setItemToEdit} />}
        </div>
    );
}

export default BloqueadoReservaList;
